const POINTER_FOCUS_SELECTOR = [
  'button',
  '[role="button"]',
  '[role="tab"]',
  '[role="switch"]',
  '[role="option"]',
  'summary',
].join(', ');

function isPointerFocusableControl(element) {
  if (!(element instanceof globalThis.HTMLElement)) return false;
  if (!element.matches(POINTER_FOCUS_SELECTOR)) return false;
  if (element.hasAttribute('disabled')) return false;
  if (element.getAttribute('aria-disabled') === 'true') return false;
  if (element.dataset.keepPointerFocus === 'true') return false;
  return true;
}

function getClosestFocusableControl(target) {
  if (!(target instanceof Element)) return null;
  const control = target.closest(POINTER_FOCUS_SELECTOR);
  return isPointerFocusableControl(control) ? control : null;
}

export function installPointerFocusGuard(doc = document) {
  if (!doc?.addEventListener) {
    return () => {};
  }

  const handlePointerUp = (event) => {
    if (typeof event.button === 'number' && event.button !== 0) return;

    const activeElement = doc.activeElement;
    const pointerTarget = getClosestFocusableControl(event.target);

    if (!isPointerFocusableControl(activeElement)) return;
    if (!pointerTarget || pointerTarget !== activeElement) return;

    Promise.resolve().then(() => {
      if (doc.activeElement === activeElement) {
        activeElement.blur();
      }
    });
  };

  doc.addEventListener('pointerup', handlePointerUp, true);
  return () => {
    doc.removeEventListener('pointerup', handlePointerUp, true);
  };
}

export default installPointerFocusGuard;
